/**
 * Keeps product prices displayed without trailing ".00" at all times.
 *
 * Why this exists: the theme's price display is correctly rendered with no
 * decimals on first page load (via the shop's money format), but a couple of
 * legacy scripts (the Slate `theme.js` variant handler, and other option/price
 * sync code) rewrite the price element's HTML when a variant option changes,
 * and those code paths hardcode 2-decimal formatting. Rather than patch every
 * script that can touch these elements, this watches them directly and
 * normalizes the text any time it changes — so the price always reads the
 * same way, on load and after every option change.
 */
(function () {
  'use strict';

  var SELECTOR = [
    '[id^="ProductPrice-"]',
    '[id^="ComparePrice-"]',
    '[id^="SaveAmount-"]',
    '.kg-craft-picker__price',
    '#craft-installment-amount'
  ].join(', ');

  // Turn "$1,300.00" -> "$1,300", but leave "$19.99" untouched.
  function stripTrailingZeroCents(text) {
    return text.replace(/(\d)\.00(?!\d)/g, '$1');
  }

  function normalize(el) {
    if (!el || !el.textContent) return;
    var next = stripTrailingZeroCents(el.textContent);
    if (next !== el.textContent) {
      el.textContent = next;
    }
  }

  function normalizeAll() {
    document.querySelectorAll(SELECTOR).forEach(normalize);
  }

  function observe(el) {
    if (el._priceFixObserved) return;
    el._priceFixObserved = true;
    var observer = new MutationObserver(function () {
      normalize(el);
    });
    observer.observe(el, { childList: true, characterData: true, subtree: true });
  }

  function init() {
    normalizeAll();
    document.querySelectorAll(SELECTOR).forEach(observe);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Fast-path: also re-check right after the theme's own variant-change event,
  // since new price elements (e.g. in re-rendered sections) may appear later.
  document.addEventListener('variantChange', function () {
    setTimeout(init, 0);
  }, true);

  if (window.jQuery) {
    jQuery(document).on('variantChange', function () {
      setTimeout(init, 0);
    });
  }
})();
